module.exports = __webpack_public_path__ + "static/img/zibo-index.aaa14f00.jpg";